import styled from '@emotion/styled'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Section } from 'src/screens/account/header/Section'
import { useJustUser } from 'src/hooks/use-user'

export function Email(props: { className?: string }) {
  const { t } = useTranslation()
  const { user } = useJustUser()
  const [show, setShow] = useState(false)

  const email = user.username
  const masked = maskEmail(email)

  return (
    <Section title={t('account:header:mail')} className={props.className}>
      <Row>
        <Text>{show ? email : masked}</Text>
        <IconButton
          onClick={() => setShow((v) => !v)}
          title={
            show
              ? t('account:header:hide_email')
              : t('account:header:show_email')
          }
        >
          {show ? <EyeOffIcon /> : <EyeIcon />}
        </IconButton>
      </Row>
    </Section>
  )
}

// name masked + domain replaced with ***.***
function maskEmail(email: string) {
  const [name] = email.split('@')

  const maskedName =
    name.length <= 2 ? name[0] + '*' : name[0] + '***' + name[name.length - 1]

  return `${maskedName}@***.***`
}

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

const Text = styled.p`
  margin: 0;
  color: ${(props) => props.theme.d.colors.text.secondary};
  font-weight: 600;
`

const IconButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  color: ${(props) => props.theme.d.colors.text.secondary};

  &:hover {
    opacity: 0.8;
  }
`

// Inline SVG icons
function EyeIcon() {
  return (
    <svg
      width='16'
      height='16'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      viewBox='0 0 24 24'
    >
      <path d='M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z' />
      <circle cx='12' cy='12' r='3' />
    </svg>
  )
}

function EyeOffIcon() {
  return (
    <svg
      width='16'
      height='16'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      viewBox='0 0 24 24'
    >
      <path d='M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7 1.36-2.06 3.08-3.92 5.06-5.44' />
      <path d='M1 1l22 22' />
      <path d='M9.53 9.53A3 3 0 0 0 12 15a3 3 0 0 0 2.47-1.34' />
    </svg>
  )
}
